import React, { FC, PropsWithChildren } from 'react';
import { Spinner } from '@/components/Loading/index';
import { ISpinnerProps } from '@/components/Loading/Spinner';
import { classnames } from '@/utils/classnames';

interface IWaitingProps extends PropsWithChildren<ISpinnerProps> {
  isFullHeight?: boolean;
  isOverlayMode?: boolean;
  isDarkMode?: boolean;
  className?: string;
}

const Waiting: FC<IWaitingProps> = ({
  children,
  isFullHeight = false,
  isOverlayMode = false,
  isDarkMode = false,
  className,
  ...props
}) => {
  return (
    <div
      className={classnames(
        'flex flex-col items-center justify-center gap-y-5',
        isFullHeight && 'flex-grow',
        isOverlayMode && 'fixed inset-0 z-[99999] h-screen w-screen',
        className
      )}
      style={{
        ...(isOverlayMode && {
          background: isDarkMode
            ? 'rgb(31 ,34,39 ,0.6)'
            : 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.4) 0.01%, rgba(255, 255, 255, 0.8) 24.48%, rgba(255, 255, 255, 0.95) 49.86%, rgba(255, 255, 255, 0.8) 76.04%, rgba(255, 255, 255, 0.5) 100%)',
        }),
      }}
    >
      <Spinner
        size="40px"
        {...props}
        color={isDarkMode ? 'white' : 'rgb(128, 166, 181)'}
      />
      <div className="text-center text-base font-regular text-gray-100 ">
        {children || 'درحال بارگذاری'}
      </div>
    </div>
  );
};

export default Waiting;
